import React, { Component } from 'react'
import styled from 'styled-components'
import PropTypes from 'prop-types'

const Container = styled.div`
  background-color: white;
  font-size: 12px;
  width: ${props => props.large ? '300px' : '150px'};
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  flex-wrap: wrap;
  padding: 10px;
  box-shadow: 10px 10px 5px -7px rgba(173,170,173,1);

`

const OptionsContainer = styled.div`
  display: flex;
  flex-direction: ${props => props.large ? 'row' : 'column'};
  flex-wrap: wrap;
`

const LegendColor = styled.div`
  margin-right: 5px;
  height: 15px;
  width: 5px;
  background-color: ${props => props.color || ''};
`
const KeyContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  margin-right: 5px;
`
const ValueContainer = styled.div`
  display: flex;
  flex: 1;
  justify-content: flex-end;
  flex-direction: row;
  align-items: center;
`
const ColorContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`

const Total = styled.div`
  display: flex;
  flex: 1
  justify-content: flex-end;
`

const Options = styled.p`
  font-size: 16px;
  font-weight: bold;
`

const Value = styled.p`
  font-weight: bold;
`


class Tool extends Component {
  renderOptions = () => {
    const { payload, withoutCurrency, label, suffix, withoutTotal, large, prefix } = this.props
    const symbol = (!withoutTotal && !withoutCurrency) ? prefix : ''
    const options = payload.map((currentValue, index) =>
      (
        <KeyContainer key={index}>
          <ColorContainer>
            <LegendColor color={currentValue.stroke || currentValue.fill} />
            <p>
              {`${currentValue.dataKey} :`}
            </p>
          </ColorContainer>
          <ValueContainer>
            {symbol !== '' ?
              <p>
                {`${symbol || ''}${(currentValue.value).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,')} ${suffix || ''}`}
              </p>
              :
              <p>
                {`${symbol || ''}${currentValue.value} ${suffix || ''}`}
              </p>
            }
          </ValueContainer>
        </KeyContainer>
      )
    )
    return (
      <div>
        <Options>{label.toUpperCase()}</Options>
        <OptionsContainer large={large}>
          {options}
        </OptionsContainer>
        {!withoutTotal &&
        <Total>
          <Value>
            {`Total: ${symbol}${payload[0].payload.total.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,')} ${suffix || ''}`}
          </Value>
        </Total>
        }
      </div>
    )
  }

  render() {
    const { active, payload, large } = this.props
    if (active && payload.length > 0) {
      return (
        <Container large={large}>
          {this.renderOptions()}
        </Container>
      )
    }

    return null
  }
}

Tool.propTypes = {
  active: PropTypes.bool,
  payload: PropTypes.array,
  label: PropTypes.string,
  suffix: PropTypes.string,
  withoutTotal: PropTypes.bool,
  withoutCurrency: PropTypes.bool,
  prefix: PropTypes.string,
}

Tool.defaultProps = {
  active: false,
  payload: [],
  label: '',
  suffix: '',
  withoutTotal: false,
  withoutCurrency: false,
  prefix: '',
}


export default Tool



// WEBPACK FOOTER //
// ./src/Components/ReportsComponents/Tool.jsx